export const POST_API = {
  GET_LIST: `https://blog.ino.school/wp-json/wp/v2/posts?_embed&_fields[]=id&_fields[]=title&_fields[]=link&_fields[]=fimg_url&_fields[]=featured_media&_fields[]=excerpt&per_page=6`,
};
